import React, { useState } from "react";
import ChartInDialogButton from "components/basic/chart-in-dialog-button/ChartInDialogButton";

export enum TableTypes {
  DEFAULT = "default",
  GROUPED = "grouped",
  TRANSPOSED = "transposed",
}

interface DatasetChartButtonWrapperProps {
  identifier: string;
  tableType: TableTypes;
}

const DatasetChartButtonWrapper: React.FC<DatasetChartButtonWrapperProps> = ({
  identifier,
  tableType,
}) => {
  const [currentIdentifiers, setCurrentIdentifiers] = useState<Array<string>>([]);
  const isSelected = currentIdentifiers.includes(identifier);

  const handleSelect = (e: React.MouseEvent) => {
    if (e.ctrlKey) {
      if (isSelected) {
        setCurrentIdentifiers(currentIdentifiers.filter(id => id !== identifier));
      } else {
        setCurrentIdentifiers([...currentIdentifiers, identifier]);
      }
    }
  };

  let identifiers;

  if (tableType === TableTypes.DEFAULT) {
    identifiers = currentIdentifiers.includes(identifier) ? currentIdentifiers : undefined;
  } else {
    identifiers = isSelected ? currentIdentifiers : undefined;
  }

  return (
    <div
      className={`non-printable ${isSelected ? "text-yellow-500" : ""}`}
      onClick={handleSelect}
    >
      <ChartInDialogButton
        identifier={identifier}
        identifiers={identifiers}
      />
    </div>
  );
};

export default DatasetChartButtonWrapper;
